import React, { useEffect, useState } from "react";
import { prestationService } from "../../../services/prestationService";
import Loader from "../../common/Loader";

const PrestationHitechPreviewModal = ({
  quotationUuid,
  quotationDetailUuid,
}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    prestationService
      .previewHitech(quotationUuid, quotationDetailUuid)
      .then((res) => setData(res.data))
      .catch(() =>
        setError("Impossible de charger l'aperçu des prestations HiTech.")
      );
  }, [quotationUuid, quotationDetailUuid]);

  return (
    <div>
      <h5>Aperçu des prestations envoyées à HiTech</h5>
      {error && <div className="text-danger">{error}</div>}
      {!data && !error && <Loader />}
      {data && (
        <>
          <div className="alert alert-warning">{data.warning}</div>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Libellé</th>
                <th>Prestation (id HiTech)</th>
                <th>Mapping résolu</th>
                <th>Montant</th>
                <th>Repli Frais de gestion</th>
              </tr>
            </thead>
            <tbody>
              {data.lignes.map((ligne, k) => (
                <tr
                  key={k}
                  className={ligne.fallback_frgest ? "table-warning" : ""}
                >
                  <td>{ligne.Libelle}</td>
                  <td>{ligne.Prestation}</td>
                  <td>{ligne.mapping_resolu}</td>
                  <td>{ligne.Prix?.[0]?.Montant} €</td>
                  <td>{ligne.fallback_frgest ? "Oui" : "Non"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default PrestationHitechPreviewModal;
